import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { EditTournamentForm } from 'local/components'

const transformTournamentData = (data) => {
  // Format the date to YYYY-MM-DD
  const formatDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toISOString().split('T')[0] // This will give us YYYY-MM-DD
  }

  // Extract time in HH:mm format
  const formatTime = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return `${String(date.getHours()).padStart(2, '0')}:${String(
      date.getMinutes()
    ).padStart(2, '0')}`
  }

  const transformed = {
    tournamentName: data.tournamentName || '',
    tournamentFullName: data.tournamentFullName || '',
    city: data.city || '',
    country: data.country
      ? {
          id: '', // Country doesn't have an id
          name: data.country,
        }
      : '',
    tournamentType: data.tournamentType || '',
    logo: data.logo || '',
    largeLogo: data.largeLogo || '',
    jurisdiction: data.jurisdiction ||
      (data.jurisdictionId
        ? {
            id: data.jurisdictionId,
            name: String(data.jurisdictionId),
          }
        : ''),
    sportType: data.sportType || '',
    venue: data.venue || '',
    website: data.website || '',
    marketingPromotion: data.marketingPromotion || false,
    startTime: formatDate(data.startTime), // Format the date here
    startTimeHour: formatTime(data.startTime), // Extract time
    endTime: formatDate(data.endTime), // Add endTime with the same formatting
    endTimeHour: formatTime(data.endTime), // Extract time
    followed: data.followed || data.isFollowed || false,
    id: data.id || '',
  }
  return transformed
}

const TournamentUpdateComponent = ({
  onSubmit,
  getTournamentById,
  tournamentId,
}) => {
  const [initialValues, setInitialValues] = useState(null)

  useEffect(() => {
    if (tournamentId) {
      getTournamentById(tournamentId)
        .then((response) => {
          const transformedData = transformTournamentData(response)
          setInitialValues(transformedData)
        })
        .catch((error) => {
          console.error('Error fetching tournament:', error)
        })
    }
  }, [tournamentId, getTournamentById])

  if (!initialValues) {
    return <div>Loading...</div>
  }

  return (
    <EditTournamentForm
      header="Update tournaments"
      onSubmit={onSubmit}
      initialValues={initialValues}
    />
  )
}

TournamentUpdateComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  getTournamentById: PropTypes.func.isRequired,
  tournamentId: PropTypes.number.isRequired,
}

export default TournamentUpdateComponent
